import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { module as BaseModule } from "modujs"

gsap.registerPlugin(ScrollTrigger)

export default class extends BaseModule {
  init() {
    this.sections = this.el.querySelectorAll("[data-timeline-section]")
    if (!this.sections.length) return
    

    this.sectionTargets = []

    this.createTimeline()
    this.setupScrollTriggers()
  }

  createTimeline() {
    this.timeline = gsap.timeline({
         paused: true,
         defaults: {
          duration: 0.5,
          ease: "linear",
         },
         })

    this.sections.forEach((section, index) => {
      const line = section.querySelector("[data-timeline-line]")
      const point = section.querySelector("[data-timeline-point]")
      const title = section.querySelector("[data-timeline-title]")
      const titleClone = section.querySelector("[data-timeline-title-clone]")
      const text = section.querySelector("[data-timeline-text]")
      const image = section.querySelector("[data-timeline-image]")

      const sectionTimeline = gsap.timeline({
        paused: false,
        defaults: {
            duration: 0.5,
            ease: "linear",
           },
       })

      sectionTimeline.set(line, {
        opacity: 1,
        scaleY: 0,
        transformOrigin: "top",
      })

      if (index !== 0) {
        const prevLine = this.sections[index - 1].querySelector("[data-timeline-line-end]")
        sectionTimeline.set(prevLine, {
          opacity: 1,
          scaleY: 0,
          transformOrigin: "top",
        })

        sectionTimeline.to(prevLine, {
            scaleY: 1,
          })
      }

      sectionTimeline.to(line, {
        scaleY: 1,
      })

      sectionTimeline.to(point, {
        scale: 1,
        opacity: 1,
      })

      gsap.set(image, { opacity: 0, scale: 0.9, transformOrigin: "top " + (index % 2 == 0 ? "left" : "right") })
      sectionTimeline.to(image, {
          opacity: 1,
          scale: 1,
          duration: 1,
          ease: "expo.out",
        }, "-=0.2")

      gsap.set(title, { opacity: 1 })
      gsap.set(titleClone, { yPercent: 100 })

      sectionTimeline.to(titleClone, {
        yPercent: 0,
        opacity: 1,
        duration: 1,
        ease: "expo.out",
      }, "-=0.8")

      sectionTimeline.to(text, {
        opacity: 1,
        duration: 1,
        ease: "power2.out",
      }, "-=0.5")

      const startLabel = `section-${index}-start`
      const endLabel = `section-${index}-end`

      this.timeline.addLabel(startLabel)
      this.timeline.add(sectionTimeline)
      this.timeline.addLabel(endLabel)

      this.sectionTargets[index] = endLabel
    })
  }

  setupScrollTriggers() {
    this.sectionTriggers = Array.from(this.sections).map((section, index) =>
      ScrollTrigger.create({
        trigger: section,
        start: "top center",
        once: true,
        onEnter: () => this.playSection(index),
      })
    )
  }

  playSection(index) {
    const targetLabel = this.sectionTargets[index]
    if (!targetLabel) return

    if (this.activeTween) {
      this.activeTween.kill()
    }

    this.activeTween = this.timeline.tweenTo(targetLabel, {
      ease: "power1.out",
      onComplete: () => {
        this.activeTween = null
      },
    })
  }

  destroy() {
    if (this.sectionTriggers) {
      this.sectionTriggers.forEach((trigger) => trigger.kill())
      this.sectionTriggers = null
    }

    if (this.activeTween) {
      this.activeTween.kill()
      this.activeTween = null
    }

    if (this.timeline) {
      this.timeline.kill()
      this.timeline = null
    }
  }
}
